import script from "./GenerateSafetyTopicsView.vue?vue&type=script&setup=true&lang=js"
export * from "./GenerateSafetyTopicsView.vue?vue&type=script&setup=true&lang=js"

import "./GenerateSafetyTopicsView.vue?vue&type=style&index=0&id=668f5e8e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-668f5e8e"]])

export default __exports__